import { nowUnixTimestamp } from '../../../utils/helpers.mjs';
import { SOUND_EDITION_V2_ABI } from '../abi/sound-edition-v2.mjs';
import { SUPER_MINTER_V1_ADDRESS, SUPER_MINTER_V1 } from '../abi/super-minter-v1.mjs';
import { SUPER_MINTER_V2_ADDRESS, SUPER_MINTER_V2 } from '../abi/super-minter-v2.mjs';
import { CacheUtils } from '../../../utils/cache-utils.mjs';

function getTierCurrentMaxMintable(tierInfo, unixTimestamp = nowUnixTimestamp()) {
  return unixTimestamp < tierInfo.cutoffTime ? tierInfo.maxMintableUpper : tierInfo.maxMintableLower;
}
const MINTER_ROLE = 2n;
async function getSuperMinterForEdition(client, { editionAddress }) {
  const cacheKey = `superMinter-${editionAddress}`;
  return CacheUtils.getOrSetCache(cacheKey, () => _getSuperMinterForEdition({ client, editionAddress }));
}
async function _getSuperMinterForEdition({
  client,
  editionAddress
}) {
  const [hasSuperMinterV1, hasSuperMinterV2] = await client.multicall({
    contracts: [
      {
        abi: SOUND_EDITION_V2_ABI,
        address: editionAddress,
        functionName: "hasAnyRole",
        args: [SUPER_MINTER_V1_ADDRESS, MINTER_ROLE]
      },
      {
        abi: SOUND_EDITION_V2_ABI,
        address: editionAddress,
        functionName: "hasAnyRole",
        args: [SUPER_MINTER_V2_ADDRESS, MINTER_ROLE]
      }
    ],
    allowFailure: false
  });
  if (hasSuperMinterV1) {
    return SUPER_MINTER_V1;
  } else if (hasSuperMinterV2) {
    return SUPER_MINTER_V2;
  }
  throw new Error("No super minter found for edition");
}

export { MINTER_ROLE, getSuperMinterForEdition, getTierCurrentMaxMintable };
